import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BidNotificationInfo, BmDataAccessFacade } from '@nexweb/shared/data-access/bm';

import { RequestActivation } from '../../../models';
import { RequestActivationService } from '../../../services';
import { NotificationComponent } from '../notification/notification.component';

@Component({
  selector: 'nexweb-requesting-tso-confirmation',
  templateUrl: './requesting-tso-confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, NotificationComponent],
})
export class RequestingTsoConfirmationComponent implements OnInit {
  @Input() bidId: number;

  public notification$: Observable<RequestActivation.ActivationRequestNotification>;
  public mustAcknowledgeMessageRead: boolean;
  public labels: RequestActivation.NotificationLabels;
  public headings: RequestActivation.NotificationHeadings;
  public dateTimeFormat: string;

  private requestActivationService = inject(RequestActivationService);
  private bmFacade = inject(BmDataAccessFacade);

  ngOnInit(): void {
    this.labels = this.requestActivationService.getConfirmationLabels();
    this.headings = this.requestActivationService.getConfirmationHeadings();
    this.dateTimeFormat = this.requestActivationService.getDateTimeFormat();

    this.initialiseData();
  }

  private initialiseData(): void {
    this.notification$ = this.bmFacade.getBidNotificationInfo(this.bidId).pipe(
      map((bidNotificationInfo: BidNotificationInfo) => {
        const bidNotificationData = {
          name: bidNotificationInfo.requestingTsoName,
          telephoneNumber: bidNotificationInfo.requestingTsoPhoneNumber,
          portfolio: bidNotificationInfo.requestingTsoPortfolioName,
          currentInstrument: {
            instrument: bidNotificationInfo.instrument,
            requestedQuantity: bidNotificationInfo.requestedQuantity,
            requestedActivationTime: bidNotificationInfo.requestFullDispatchTime,
            earlyActivationRequested: bidNotificationInfo.earlyActivation,
          } as RequestActivation.NotificationCurrentInstrument,
          subsequentInstrument: {
            instrument: bidNotificationInfo.subsequentInstrument,
            requestedQuantity: bidNotificationInfo.subsequentRequestedQuantity,
            requestedActivationTime: bidNotificationInfo.subsequentDefaultFullDispatchTime,
          } as RequestActivation.NotificationSubsequentInstrument,
        } as RequestActivation.ActivationRequestNotification;

        return bidNotificationData;
      }),
    );
  }
}
